// Real products & brand copy pulled from whipitup.shop
export const HERO_FLIPS = [
  "your next ritual.",
  "a smoother routine.",
  "the standard.",
  "your glow-up.",
  "the softest skin ever."
];

export const ANNOUNCEMENTS = [
  "ALL ITEMS ARE CRAFTED WITH LOVE — NATURALLY!",
  "ORDERS MAY EXPERIENCE SLIGHT DELAYS — THANKS FOR YOUR PATIENCE.",
  "ASK ABOUT OUR WHOLESALE PRICES.",
  "BUNDLE THE GLOW TRIO FROM $60."
];

export const BRAND_COPY = {
  headline: "WHIP IT UP",
  formulaDisclaimer:
    "The formulas are crafted with synthetic fragrance oils along with 100% natural ingredients, including shea butter, rosehip seed, vitamin E and castor oils.",
  whyYouLoveIt:
    "Whipped to airy perfection, this body butter melts into your skin, delivering deep hydration with a glow to match. Made from 100% natural ingredients and packed with shea butter + essential oils, it leaves you soft, smooth, and never greasy. It's your skin's new obsession.",
  keyBenefits: [
    "Deep moisture that kicks dryness to the curb",
    "100% natural, skin-loving ingredients",
    "Fast-absorbing with a silky feel",
    "Leaves your skin soft, smooth, and glowing"
  ],
  favoriteSayings: [
    "Experience the butter that you didn't know you needed",
    "Stay smooth and Glowing"
  ],
  returnPolicy: {
    title: "No Returns, Just Love",
    body: "Because our body products are made fresh and personal, we don't accept returns. However, we're always here to help if you have questions before ordering!"
  },
  aboutUs: {
    founder: "Ajasiz Johnson (AJ)",
    paragraphs: [
      "Welcome to Whip It Up, where self-care meets luxury! Founded by Ajasiz Johnson (AJ), Whip It Up is dedicated to creating high-quality, nourishing body care products that inspire confidence and elevate your everyday routine.",
      "AJ's journey began with a passion for natural ingredients and a vision to craft products that not only smell amazing but also pamper the skin. Each item in our collection, from our rich body butters to our rejuvenating body oils and captivating perfumes/colognes, is meticulously formulated to provide the best in skincare.",
      "At Whip It Up, we believe that self-care should be a delightful experience. That's why we offer a range of scents inspired by popular fragrances, ensuring there's something for everyone. Our products are designed to help you feel good inside and out, making every day a little more special.",
      "Join us on this journey of self-love and indulgence. Experience the Whip It Up and experience the glow!"
    ]
  }
};

export const INGREDIENTS_BY_TYPE = {
  "body-butter": {
    label: "Body Butter",
    list: [
      "Raw, unrefined shea butter",
      "Organic rosehip seed oil",
      "Organic castor oil",
      "Organic vitamin E oil",
      "Arrowroot powder",
      "Fragrance oil"
    ],
    note: "100% pure and natural."
  },
  "body-oil": {
    label: "Body Oil",
    list: [
      "Organic rosehip seed oil",
      "Castor oil",
      "Organic vitamin E oil",
      "Fragrance oil"
    ],
    note: "100% pure and natural."
  },
  "spray-oil": {
    label: "Spray Oil",
    list: ["Fragrance oil"],
    note: "Applied over body butter for a signature glow."
  },
  "glow-trio": {
    label: "Glow Trio",
    list: [
      "Body Butter — raw shea, rosehip, castor, vitamin E, arrowroot, fragrance oil",
      "Body Oil — rosehip, castor, vitamin E, fragrance oil",
      "Spray Oil — fragrance oil"
    ],
    note: "All three, engineered as a system."
  }
};

export const HOW_TO_USE = {
  "body-butter":
    "After shower, while your skin is still damp, apply the desired amount over the entire body. OK to apply extra on dry patches.",
  "body-oil":
    "After shower. Can also rub a drop or two into the palm of your hands to use as a moisturizer throughout the day as needed.",
  "spray-oil":
    "After applying body butter, spray until your heart's content! Not recommended to spray directly onto clothing as it may leave an oil stain.",
  "glow-trio":
    "Butter first, then oil, then spray. For extra radiance, layer for that double-drip glow."
};

export const GLOW_TIP =
  "For extra radiance, layer with your fave Whip It Up product — butter first, then oil for that double-drip glow.";

// Note: fragrance names reference real designer scents. Whip It Up is not
// affiliated with those designers. See disclaimer.
export const FRAGRANCE_DISCLAIMER =
  "The aroma of these oils are similar to the fragrances listed, but are not made by (or for) the original designer. Whip It Up is not affiliated with the original designer or manufacturer as oils names, trademarks and copyrights are owned by their respective manufacturers/designers. The aromas that we offer are similar to the original designer fragrances, but are not to be confused with any aspect of the original designer.";

export const FRAGRANCES_HER = [
  { code: "000", name: "Unscented", notes: "A perfect blend of 100% pure and natural ingredients — raw shea, rosehip, castor, and vitamin E. A smooth and creamy delight." },
  { code: "117", name: "Inspired by Alien", notes: "Top: sambac jasmine · Heart: cashmere wood · Base: white amber. For the nonconformer." },
  { code: "227", name: "Inspired by Black Woman", notes: "Top: plum, orange, bergamot · Heart: jasmine, rose, violet · Base: sandalwood, vanilla, musk. Empowerment in a jar." },
  { code: "316", name: "Inspired by I Want Choo", notes: "Top: mandarin, peach · Heart: jasmine, red spider lily · Base: vanilla. Luxury awaits.", outOfStock: true },
  { code: "331", name: "Inspired by Mademoiselle Intense", notes: "Top: sicilian orange, calabrian bergamot · Heart: rose, jasmine · Base: patchouli, tonka bean, vanilla." },
  { code: "332", name: "Inspired by Kayali Vanilla", notes: "Top: vanilla orchid, jasmine · Middle: brown sugar, tonka · Base: amber, amberwood, musk, patchouli." },
  { code: "508", name: "Inspired by Perry Ellis 360", notes: "Top: lily, tangerine, melon · Heart: osmanthus, rose, lavender · Base: sandalwood, amber." },
  { code: "523", name: "Inspired by Bright Crystal", notes: "Top: pomegranate, yuzu, iced accord · Heart: magnolia, lotus, peony · Base: amber, musks, mahogany." },
  { code: "525", name: "Inspired by Baccarat Rouge", notes: "Top: saffron, jasmine · Heart: amberwood, ambergris · Base: fir resin, cedarwood. Spicy perfection." },
  { code: "614", name: "Inspired by Love Don't Be Shy", notes: "Top: neroli, bergamot · Heart: bulgarian rose, orange blossom · Base: marshmallow, vanilla, musk, pomegranate." },
  { code: "717", name: "Inspired by Mango Butter", notes: "Top: orange, melon, banana, green · Heart: jasmine, lily, apple · Base: cotton candy, musk, sandalwood." },
  { code: "737", name: "Inspired by Burberry Her", notes: "Top: raspberry, cherry, strawberry, blackberry, blueberry · Heart: violet, jasmine · Base: woods, musk, amber." },
  { code: "828", name: "Inspired by Born In Roma", notes: "Top: calabrian bergamot, violet, pepper · Heart: jasmine grandiflorum, vetiver, mineral salt · Base: guaiac wood, cashmeran, vanilla." },
  { code: "828B", name: "Inspired by Born In Roma Intense", notes: "Top: vanilla · Heart: lavender · Base: vetiver. Italian luxury." },
  { code: "927", name: "Inspired by Delina Exclusif", notes: "Top: pear, lychee, grapefruit · Heart: damascena rose, incense, vetiver · Base: vanilla, musk, evernyl.", outOfStock: true }
];

export const FRAGRANCES_HIM = [
  { code: "000", name: "Unscented", notes: "A perfect blend of 100% pure and natural ingredients — raw shea, rosehip, castor, and vitamin E." },
  { code: "122", name: "Inspired by Sauvage EDP", notes: "Top: calabrian bergamot, sichuan pepper · Heart: star anise, nutmeg, lavender · Base: papua new guinean vanilla, ambroxan." },
  { code: "326", name: "Inspired by Azzaro Chrome", notes: "Top: bergamot, lemon, pineapple · Heart: jasmine, water, coriander · Base: cedarwood, musk, amber." },
  { code: "525", name: "Inspired by Baccarat Rouge", notes: "Top: saffron, jasmine · Heart: amberwood, ambergris · Base: fir resin, cedarwood." },
  { code: "615", name: "Inspired by YSL Myslf", notes: "Top: calabrian bergamot, bergamot · Heart: tunisian orange blossom · Base: patchouli. Sophistication meets versatility." },
  { code: "808", name: "Inspired by Creed Himalaya", notes: "Top: grapefruit, calabrian bergamot, sicilian lemon · Heart: sandalwood · Base: musk, ambergris, cedarwood." },
  { code: "818", name: "Inspired by Calvin Klein Escape", notes: "Top: eucalyptus, melon, juniper · Heart: grapefruit, mango, rosemary · Base: sandalwood, patchouli, fir." },
  { code: "904", name: "Inspired by Paco Rabanne Phantom", notes: "Top: lemon · Heart: lavender, patchouli, vetiver · Base: wood, vanilla." }
];

export const CATEGORIES = [
  {
    id: "body-butter",
    name: "Body Butter",
    tag: "01 / SIGNATURE",
    blurb: "Whipped triple-butter formula. Non-greasy. Naturally scented.",
    image: "https://whipitup.shop/cdn/shop/files/for_her.svg?v=1744515429&width=800"
  },
  {
    id: "body-oil",
    name: "Body Oil",
    tag: "02 / GLOW",
    blurb: "Pour it. Rub it. Glow on.",
    image: "https://whipitup.shop/cdn/shop/files/body_oil_fbbbbcba-de2c-4ae5-bf68-b8bc17182b97.svg?v=1744515284&width=800"
  },
  {
    id: "spray-oil",
    name: "Spray Oil",
    tag: "03 / MIST",
    blurb: "A weightless, spray-on finish. Instant sheen.",
    image: "https://customer-assets.emergentagent.com/job_neon-workshop-3/artifacts/7rzr8vvt_Jul_14__2026__05_36_03_PM-removebg-preview.png"
  },
  {
    id: "glow-trio",
    name: "Glow Trio",
    tag: "04 / BUNDLE",
    blurb: "Butter + Oil + Spray. Engineered as a set. Save when you stack.",
    image: "https://customer-assets.emergentagent.com/job_neon-workshop-3/artifacts/cp68xzp6_Gemini_Generated_Image_iqnlwkiqnlwkiqnl.webp"
  }
];

const HERO_JAR_IMG =
  "https://customer-assets.emergentagent.com/job_neon-workshop-3/artifacts/r7hwkp82_ChatGPT_Image_Jul_10__2026__11_39_43_AM-removebg-preview.png";

const BODY_OIL_IMG =
  "https://customer-assets.emergentagent.com/job_neon-workshop-3/artifacts/fzbhdhtm_ChatGPT_Image_Jul_13__2026__12_39_11_PM-removebg-preview.png";

const SPRAY_OIL_IMG =
  "https://customer-assets.emergentagent.com/job_neon-workshop-3/artifacts/7rzr8vvt_Jul_14__2026__05_36_03_PM-removebg-preview.png";

const GLOW_TRIO_IMG =
  "https://customer-assets.emergentagent.com/job_neon-workshop-3/artifacts/cp68xzp6_Gemini_Generated_Image_iqnlwkiqnlwkiqnl.webp";

export const PRODUCTS = [
  {
    id: "body-butter",
    name: "Body Butter",
    tagline: "Whipped. Rich. Absorbs in seconds.",
    tagline_her: "Floral, warm, unforgettable.",
    tagline_him: "Smoky, grounded, magnetic.",
    price: 35,
    category: "body-butter",
    hasAudience: true,
    badge: "BEST SELLER",
    image: HERO_JAR_IMG,
    scent: "Choose your fragrance",
    size: "12 oz",
    description:
      "A whipped, ultralight body butter engineered for soft skin without the grease. Triple-butter base with cold-pressed carrier oils. Blended in micro-batches and hand-packed."
  },
  {
    id: "body-oil",
    name: "Body Oil",
    tagline: "Pour it. Rub it. Glow on.",
    tagline_her: "Silky, floral, everyday glow.",
    tagline_him: "Warm, woody, all-day sheen.",
    price: 12,
    category: "body-oil",
    hasAudience: true,
    image: BODY_OIL_IMG,
    scent: "Choose your fragrance",
    size: "2 oz",
    description:
      "A five-oil, non-comedogenic body oil that seals in moisture and leaves a soft sheen. Formulated to absorb without slick residue."
  },
  {
    id: "spray-oil",
    name: "Spray Oil",
    tagline: "Mist. Set. Radiate.",
    tagline_her: "Rose. Jasmine. Musk.",
    tagline_him: "Cedar. Bergamot. Sandalwood.",
    price: 20,
    category: "spray-oil",
    hasAudience: true,
    image: SPRAY_OIL_IMG,
    scent: "Choose your fragrance",
    size: "4 oz",
    description:
      "A finely-atomized spray oil that lays down a weightless veil of moisture and scent. Fastest absorption in the line."
  },
  {
    id: "glow-trio",
    name: "Glow Trio",
    tagline: "Butter. Oil. Spray. The full ritual.",
    tagline_her: "Butter. Oil. Spray. The full ritual.",
    tagline_him: "Butter. Oil. Spray. The full ritual.",
    price: 60,
    originalPrice: 67,
    category: "glow-trio",
    hasAudience: true,
    badge: "BUNDLE $60",
    image: GLOW_TRIO_IMG,
    scent: "Choose your fragrance",
    size: "3-piece kit",
    description:
      "The complete Whip It Up system. Whip on the butter, seal with the oil, mist with the spray. Save when you stack."
  }
];

export const PROCESS_STEPS = [
  {
    number: "01",
    title: "SOURCE",
    subtitle: "Raw. Ethical. Traceable.",
    detail:
      "Unrefined shea from West African co-ops. Cold-pressed carrier oils from single-origin farms. Every batch of raw material is tested for purity before it touches our kitchen."
  },
  {
    number: "02",
    title: "WHIP",
    subtitle: "Micro-batched, by hand.",
    detail:
      "We whip in small batches — never mass-produced. No water, no fillers, no synthetic thickeners. Each jar is engineered for absorption, not shelf-life padding."
  },
  {
    number: "03",
    title: "DELIVER",
    subtitle: "Sealed within 48 hrs.",
    detail:
      "Hand-poured, hand-labeled, shipped within 48 hours of the whip. Insulated packaging keeps texture on temperature. Signature unboxing every time."
  }
];

export const BLOG_POSTS = [
  {
    id: "shea-butter-allergy",
    title: "Shea Butter Allergy: What You Actually Need To Know",
    date: "May 10, 2025",
    readTime: "4 min",
    excerpt:
      "Although shea butter comes from nuts of the shea tree, it isn't the same as peanuts or tree nuts that commonly trigger allergic reactions. Here's the science, straight.",
    image:
      "https://images.unsplash.com/photo-1573812461383-e5f8b759d12e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxzaGVhJTIwYnV0dGVyfGVufDB8fHx8MTc4MzYyNTQ4OXww&ixlib=rb-4.1.0&q=85",
    body: [
      "Shea butter is extracted from the nut of the shea tree (Vitellaria paradoxa), native to West Africa. Because it's technically a 'nut,' one of the most common questions we get is whether people with tree-nut or peanut allergies can safely use it.",
      "The short answer: shea butter is not classified in the same family as peanuts (a legume) or common tree nuts like walnut, cashew, or almond. The allergenic proteins that trigger those reactions are largely absent — or present at trace, non-reactive levels — in unrefined shea butter.",
      "That said, we always recommend a patch test. Rub a pea-sized amount into your inner forearm and wait 24 hours. If your skin is happy, you're good. If not, we make butter-free formulas — reach out and we'll point you to them."
    ]
  },
  {
    id: "shea-cocoa-difference",
    title: "Shea Butter vs. Cocoa Butter: The Real Difference",
    date: "May 3, 2025",
    readTime: "5 min",
    excerpt:
      "As a kid I grew up on Vaseline while my friends had that good-smelling cocoa butter. Here's what actually separates the two — and why we blend both.",
    image:
      "https://images.unsplash.com/photo-1633793566189-8e9fe6f817fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxza2luY2FyZSUyMGx1eHVyeXxlbnwwfHx8fDE3ODM2MjU0ODN8MA&ixlib=rb-4.1.0&q=85",
    body: [
      "Shea butter and cocoa butter are both plant-derived fats, but they behave very differently on skin. Shea is softer, absorbs faster, and carries higher levels of vitamins A and E. Cocoa is denser, richer, and forms a more protective barrier.",
      "In every Whip it Up jar, we blend both — shea for absorption, cocoa for the seal. Add a whipped mango butter for that pillowy texture, and you've got the base that our whole line is built on.",
      "If you're deciding between the two on their own: shea for daily glow, cocoa for deep repair. Or just get the whipped combo and stop thinking about it."
    ]
  },
  {
    id: "why-we-whip",
    title: "Why We Whip (And Why It Matters)",
    date: "April 22, 2025",
    readTime: "3 min",
    excerpt:
      "Whipping isn't just texture — it changes how the product performs on your skin. Here's the mechanical breakdown.",
    image:
      "https://images.unsplash.com/photo-1741017778557-31eaf775ce0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxjcmVhbSUyMHNwbGFzaHxlbnwwfHx8fDE3ODM2MjU0ODN8MA&ixlib=rb-4.1.0&q=85",
    body: [
      "Whipping introduces air into the fat matrix. That means lighter density, faster spread, and dramatically better absorption. A whipped butter can penetrate skin in seconds — an unwhipped one sits on top and feels greasy.",
      "We whip cold, then rest, then re-whip. That double-cycle is what gives our jars that mousse-like lift you feel when you dip a finger in.",
      "It's more work. It's worth it."
    ]
  }
];

export const TESTIMONIALS = [
  { name: "Jordan M.", location: "Brooklyn, NY", text: "I've tried every 'natural' butter out there. Nothing whips like this. Absorbs in seconds." },
  { name: "Aaliyah S.", location: "Atlanta, GA", text: "The For Him is a menace. My boyfriend stole mine — had to reorder immediately." },
  { name: "Priya R.", location: "Austin, TX", text: "Spray oil after the shower has become non-negotiable. Skin has never looked better." },
  { name: "Marcus T.", location: "Oakland, CA", text: "Finally, a men's skincare product that doesn't smell like a hotel lobby. Cedar-bergamot is elite." }
];
